module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"all":"全部"},"en":{"all":"All"},"de":{"all":"Alle"},"fr":{"all":"Tout"},"es":{"all":"Todo"},"jp":{"all":"すべて"},"pt":{"all":"Todos"},"it":{"all":"tutto"},"tw":{"all":"全部"},"kr":{"all":"모두"},"id":{"all":"Beranda"},"ru":{"all":"Главная"}}')
  delete Component.options._Ctor
}
